var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "Firmware-version" },
    [
      _c("pageTitle", _vm._b({}, "pageTitle", { ..._vm.pT }, false)),
      _c(
        "business-group",
        {
          ref: "businessGroup",
          attrs: {
            tableConfig: { ..._vm.tableConfig },
            formConfig: { ..._vm.formConfig },
          },
          scopedSlots: _vm._u([
            {
              key: "formSlot",
              fn: function (formSlot) {
                return [
                  _c(
                    "a-form-item",
                    [
                      _c(
                        "a-select",
                        {
                          directives: [
                            {
                              name: "decorator",
                              rawName: "v-decorator",
                              value: ["type"],
                              expression: "['type']",
                            },
                          ],
                          staticStyle: { width: "200px" },
                          attrs: { placeholder: "请选择说明书类型" },
                        },
                        _vm._l(_vm.insTypes, function (value, key) {
                          return _c(
                            "a-select-option",
                            { key: Number(key), attrs: { value: Number(key) } },
                            [_vm._v(_vm._s(value))]
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-form-item",
                    [
                      _c("a-input", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: ["name"],
                            expression: "['name']",
                          },
                        ],
                        staticStyle: {
                          width: "250px",
                          "margin-right": "10px",
                          "vertical-align": "middle",
                        },
                        attrs: { placeholder: "请输入说明书名称" },
                      }),
                    ],
                    1
                  ),
                ]
              },
            },
            {
              key: "type",
              fn: function (record) {
                return [_vm._v(" " + _vm._s(_vm.insTypes[record.type]) + " ")]
              },
            },
            {
              key: "region",
              fn: function (record) {
                return [
                  _vm._v(" " + _vm._s(_vm.getRegion(record.region)) + " "),
                ]
              },
            },
            {
              key: "releaseDate",
              fn: function (record) {
                return [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.dataFormatStr(record.releaseDate, "YYYY-MM-DD")
                      ) +
                      " "
                  ),
                ]
              },
            },
            {
              key: "createTime",
              fn: function (record) {
                return [
                  _vm._v(
                    " " + _vm._s(_vm.dataFormatStr(record.createTime)) + " "
                  ),
                ]
              },
            },
            {
              key: "updateTime",
              fn: function (record) {
                return [
                  _vm._v(
                    " " + _vm._s(_vm.dataFormatStr(record.updateTime)) + " "
                  ),
                ]
              },
            },
            {
              key: "download",
              fn: function (record) {
                return [
                  _c("a", { attrs: { href: record.url, target: "_blank" } }, [
                    _vm._v("下载"),
                  ]),
                ]
              },
            },
            {
              key: "action",
              fn: function (record) {
                return [
                  _c(
                    "a-button",
                    {
                      attrs: { type: "link" },
                      on: {
                        click: function ($event) {
                          return _vm.edit(record)
                        },
                      },
                    },
                    [_vm._v("编辑")]
                  ),
                  _c(
                    "a-button",
                    {
                      attrs: { type: "link" },
                      on: {
                        click: function ($event) {
                          return _vm.del(record)
                        },
                      },
                    },
                    [_vm._v("删除")]
                  ),
                ]
              },
            },
          ]),
        },
        [
          _c(
            "template",
            { slot: "formRight" },
            [
              _c(
                "a-button",
                { attrs: { type: "primary" }, on: { click: _vm.add } },
                [_vm._v("新增")]
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "a-modal",
        {
          attrs: {
            visible: _vm.visible,
            title: _vm.title,
            destroyOnClose: "",
            maskClosable: false,
          },
          on: {
            ok: function ($event) {
              return _vm.submitForm("ruleForm")
            },
            cancel: function ($event) {
              return _vm.resetForm("ruleForm")
            },
          },
        },
        [
          _c(
            "a-form-model",
            {
              ref: "ruleForm",
              staticClass: "Firmware-version_ruleForm",
              attrs: { model: _vm.ruleForm, rules: _vm.rules },
            },
            [
              _c(
                "a-form-model-item",
                { attrs: { label: "说明书名称", prop: "name" } },
                [
                  _c("a-input", {
                    attrs: {
                      type: "text",
                      placeholder: "请输入说明书名称",
                      showCount: "",
                      "max-length": 64,
                    },
                    model: {
                      value: _vm.ruleForm.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm, "name", $$v)
                      },
                      expression: "ruleForm.name",
                    },
                  }),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                { attrs: { label: "说明书语言", prop: "lang" } },
                [
                  _c(
                    "a-select",
                    {
                      attrs: { placeholder: "请选择说明书类型" },
                      model: {
                        value: _vm.ruleForm.lang,
                        callback: function ($$v) {
                          _vm.$set(_vm.ruleForm, "lang", $$v)
                        },
                        expression: "ruleForm.lang",
                      },
                    },
                    _vm._l(_vm.langs, function (lang) {
                      return _c(
                        "a-select-option",
                        { key: lang, attrs: { value: lang } },
                        [_vm._v(" " + _vm._s(lang) + " ")]
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                { attrs: { label: "说明书类型", prop: "type" } },
                [
                  _c(
                    "a-select",
                    {
                      attrs: { placeholder: "请选择说明书类型" },
                      model: {
                        value: _vm.ruleForm.type,
                        callback: function ($$v) {
                          _vm.$set(_vm.ruleForm, "type", $$v)
                        },
                        expression: "ruleForm.type",
                      },
                    },
                    _vm._l(_vm.insTypes, function (value, key) {
                      return _c(
                        "a-select-option",
                        { key: Number(key), attrs: { value: Number(key) } },
                        [_vm._v(" " + _vm._s(value) + " ")]
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                { attrs: { label: "说明区域", prop: "lang" } },
                [
                  _c(
                    "a-select",
                    {
                      attrs: { placeholder: "请选择说明书区域" },
                      model: {
                        value: _vm.ruleForm.region,
                        callback: function ($$v) {
                          _vm.$set(_vm.ruleForm, "region", $$v)
                        },
                        expression: "ruleForm.region",
                      },
                    },
                    _vm._l(_vm.region, function (el) {
                      return _c(
                        "a-select-option",
                        {
                          key: Number(el.value),
                          attrs: { value: Number(el.value) },
                        },
                        [_vm._v(" " + _vm._s(el.label) + " ")]
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                { attrs: { label: "上传说明书", prop: "url" } },
                [
                  _c(
                    "a-upload",
                    {
                      staticClass: "m-upload",
                      attrs: {
                        name: "url",
                        "before-upload": _vm.beforeUpload,
                        remove: _vm.remove,
                        "file-list": _vm.files,
                        disabled: !_vm.nowTitleIsNew,
                      },
                      model: {
                        value: _vm.ruleForm.url,
                        callback: function ($$v) {
                          _vm.$set(_vm.ruleForm, "url", $$v)
                        },
                        expression: "ruleForm.url",
                      },
                    },
                    [
                      _vm.files.length <= 0
                        ? _c("a-icon", {
                            attrs: { type: _vm.upLoading ? "loading" : "plus" },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }